import type {BsdfPrincipledSockets} from "#material/nodes/shader/bsdf-principled/definition"
import type {InputMaterialConnection, SettingValueOfType} from "#material/sockets/definition"
import type {MaterialNodeInputs, MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<BsdfPrincipledSockets>
type Previous = Omit<Current, "inputs" | "settings"> & {
    inputs: MaterialNodeInputs<BsdfPrincipledSockets> & {
        subsurfaceColor?: InputMaterialConnection<"color">
        transmissionRoughness?: InputMaterialConnection<"float">
        surfaceMixWeight?: InputMaterialConnection<"float">
    }
    settings: MaterialNodeSettings<BsdfPrincipledSockets> & {
        subsurfaceColor?: SettingValueOfType<"color">
        transmissionRoughness?: SettingValueOfType<"float">
        surfaceMixWeight?: SettingValueOfType<"float">
    }
}

export const dropSettingsNoRendererReads: Version<Previous, Current> = {
    toNextVersion: ({
        inputs: {subsurfaceColor: _linkedColor, transmissionRoughness: _linkedRoughness, surfaceMixWeight: _linkedWeight, ...inputs} = {},
        settings: {subsurfaceColor, transmissionRoughness, surfaceMixWeight, ...settings} = {},
        ...parameters
    }) => ({...parameters, inputs, settings}),
}
